import { render, staticRenderFns } from "./ValidateCertificate.vue?vue&type=template&id=12c2e539&scoped=true"
import script from "./ValidateCertificate.vue?vue&type=script&lang=js"
export * from "./ValidateCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2e539",
  null
  
)

export default component.exports